<template>
	<EpkHeader />
	<div class="layout">
		<div class="layout__header">
			<div class="layout__header-info" style="align-items: flex-start">
				<button class="layout__header-goBack" @click="goBack">
					<svg width="20" height="20">
						<use xlink:href="sprite.svg#arrow-left"></use>
					</svg>
					<p>Вернуться назад</p>
				</button>
				<slot name="layout__header-contacts" />
			</div>
			<div class="layout__header-info">
				<p class="title">{{ 'Руководство пользователя' + props.title }}</p>
				<slot name="layout__header-info" />
			</div>
		</div>
		<div class="layout__content">
			<slot name="layout__content" />
		</div>
	</div>
</template>

<script setup>
import EpkHeader from '@/components/EpkHeader/EpkHeader.vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
	title: {
		type: String,
		default: '',
	},
	goBackUrl: {
		type: String,
		default: 'https://epk.mcx.ru',
	},
});

const goBack = async () => {
	if (props.goBackUrl === 'https://epk.mcx.ru') {
		window.location.href = props.goBackUrl;
		return;
	}
	await router.push({ path: props.goBackUrl });
};
</script>

<style lang="scss">
@import './DefaultLayout.scss';
</style>
